import React from 'react';
const About = () => {
    return (
        <div>
            <h1>About Codechef-Peacer</h1>
            <p className='my-1'>
                App
          </p>
            <p className="bg-dark p">
                <strong>Version : </strong>1.0.0
          </p>

        </div>
    )
}
export default About;
